import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFilterByStatusModal = createSelector(
  [(store: RootState) => store.documentsSignerList.showFilterByStatusModal],
  (status) => status
);
